let cartIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="30.85" height="28.922" viewBox="0 0 30.85 28.922"><path id="Icon_metro-cart" data-name="Icon metro-cart" d="M14.139,29.885a2.892,2.892,0,1,1-2.892-2.892,2.892,2.892,0,0,1,2.892,2.892Zm19.28,0a2.892,2.892,0,1,1-2.892-2.892A2.892,2.892,0,0,1,33.419,29.885Zm0-12.532V5.784H10.283A1.928,1.928,0,0,0,8.355,3.856H2.571V5.784H6.427L7.875,18.2a3.855,3.855,0,0,0,2.408,6.867H33.419V23.136H10.283a1.928,1.928,0,0,1-1.928-1.928c0-.007,0-.013,0-.02l25.064-3.836Z" transform="translate(-2.57 -3.855)" fill="#002445"/></svg>';

document.documentElement.style.setProperty('--recommendedHeight', 0+"px");
	
    
    function isInRecommended(id){
      let returnId = -1;
      if(recommended.length > 0){
        recommended.forEach(function(product, index){
          if(product.id == id){
            returnId = index;
          }
        });
      }
      return returnId;
    }
      
    function isInPrintRecommended(id){
      let returnId = -1;
      if(recommendedToPrint.length > 0){
        recommendedToPrint.forEach(function(product, index){
          if(product.id == id){
            returnId = index;
          }
        });
      }
      return returnId;
    }
      
    function chargePrintRecommended(){
      cleanRecommended();
      let productToInsert = maxArray - recommendedToPrint.length;
      if(productToInsert > 0 && productToInsert < recommended.length){
        for (let i = 0; i < productToInsert; i++){
          if(recommended.length > 0){
            let putIndex = getRandomInt(recommended.length - 1);
            recommendedToPrint.push(recommended[putIndex]);
            recommended.splice(putIndex, 1);
          }
        }
      }
      
      html = '<h4 class="titleLev4 colorPrimary">'+titoloSlider+'</h4><div id="recommendetionSlider">';
      recommendedToPrint.forEach(function(product, index){
        let price;
        if(product.compare_at_price == ""){
          price = '<span style="display: inline-block" class="price">'+product.price+'</span>';
        }
        else{
          price = '<span style="display: inline-block"  class="sale-price">'+product.price+'</span><span class="barredprice">'+product.compare_at_price+'</span>';
        }
        html += '<div id="slide-'+(index+1)+'" class="slideRecommended"><div class="leftCol"><a href="https://braccialettiaua.com/products/'+product.handle+'" class="resizer"><div class="imgContainer"><img src="//cdn.shopify.com/s/files/1/0581/2459/9503/'+product.preview+'"/></div></a><div class="text"><a style="display: block" href="https://braccialettiaua.com/products/'+product.handle+'" class="CartItem__Title Heading colorPrimary m-0">'+product.title+'</a><span style="display: flex; align-items:center;">'+price+'</span><button data-var_id="'+product.variant+'" class="ad_to_cart_coll"><span class="addButton">Aggiungi al carrello</span></button></div></div></div>';
      });
      html += '</div>';
      document.addEventListener("DOMContentLoaded", e=>{
        document.getElementById("recommendetionContainer").innerHTML = html;
        bindSlider();
        bindAddToCartRecommended();
      });
      
    }
      
    function bindSlider(){
      $('#recommendetionSlider').slick({
        infinite: true,
        draggable: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchThreshold: 1000,
        dots: true,
        arrows: false
      });
      
      let recommendedContainer = document.getElementById("recommendetionContainer");
      if(recommendedContainer != null){ 
        document.addEventListener("resize", e=>{
          if(recommendedContainer != null){
            document.documentElement.style.setProperty('--recommendedHeight', recommendedContainer.offsetHeight+"px");
          }
          else{
            document.documentElement.style.setProperty('--recommendedHeight', 0+"px");
          }
        });
        document.documentElement.style.setProperty('--recommendedHeight', recommendedContainer.offsetHeight+"px");
      }
    }
      
    function bindAddToCartRecommended(){
      document.querySelectorAll(".ad_to_cart_coll").forEach(function(button, index){
        button.addEventListener("click", e=>{    
          var ID = $(button).attr("data-var_id");
          addItemToCart(ID, 1);
        });
      });
      
      function addItemToCart(variant_id, qty) {
        data = {
          "id": variant_id,
          "quantity": qty
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function(data) {
            if(typeof updateFreeProduct == "function"){
              updateFreeProduct(null, data.id);
            }
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true  //this code is for prestige theme, is to refresh the cart
            }));
          }   

        }); 

      }
    }
      
    function getRandomInt(max) {
      return Math.floor(Math.random() * max);
    }
    
    function cleanRecommended(){
      let toDelete;
      recommendedToPrint.forEach(function(product, index){
      	toDelete = -1;
        recommended.forEach(function(innerProduct, innerIndex){
          if(product.id == innerProduct.id){
          	toDelete = innerIndex;
          }
        });
        if(toDelete != -1){
          recommended.splice(toDelete, 1);
        }
      });
    }
      
    function orderRecommended(){
      let array;
      for (let i = 0; i < recommended.length; i++) {
        for (let k = 0; k < recommended.length; k++){
          if(recommended[i].occorrenze > recommended[k].occorrenze){
            array = recommended[i];
            recommended[i] = recommended[k];
            recommended[k] = array;
          }
        }
      }
    }